import React from "react";
import moment from "moment";
import { useSecondProcess } from "./useSecondProcess";
import { validateRole } from "../../util/utilFunction";
import { bulan, pekerjaanSPTim2, shiftTim2 } from "../../util/constant";
import Select from "react-select";
import {
  pekerjaanPrinting,
  pekerjaanSP,
  constMesinSP,
  constWarnaPrinting,
  shiftTim1,
  rejectSP,
  rejectPR,
  rejectSPTim2,
  constMesinSPTim2,
  rejectPRTim2,
} from "../../util/constant";
import CloseLogo from "../../Assets/close_icon.png";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import "./SecondProcess.css";

/* ====== Komponen kecil (di luar SecondProcess agar input tidak kehilangan fokus) ====== */
const Field = ({
  label,
  required,
  error,
  errorText,
  className = "",
  children,
}) => (
  <div className={`sp_field ${className}`}>
    <label className={error ? "sp_label sp_label_error" : "sp_label"}>
      {label}
      {required ? <span className="sp_req">*</span> : ""}
    </label>
    {children}
    {error && errorText ? (
      <span className="sp_err_text">{errorText}</span>
    ) : null}
  </div>
);

const PopupError = ({ show }) =>
  show ? (
    <p className="sp_error_banner sp_error_inline">
      Mohon lengkapi kolom yang berwarna merah
    </p>
  ) : null;

const NumInput = ({ error, ...props }) => (
  <input
    type="number"
    className={error ? "sp_input sp_input_error" : "sp_input"}
    onWheel={(e) => e.target.blur()}
    {...props}
  />
);

const StepButtons = ({ onRemove, onAdd }) => (
  <div className="sp_stepper">
    <button className="button_plus" onClick={onRemove}>
      &#8722;
    </button>
    <button className="button_plus" onClick={onAdd}>
      &#43;
    </button>
  </div>
);

const PopupHead = ({ title, onClose }) => (
  <div className="sp_popup_head">
    <p className="sp_popup_title">{title}</p>
    <img
      className="width_edit_logo"
      src={CloseLogo}
      onClick={onClose}
      alt="close_logo"
    />
  </div>
);

const SecondProcess = () => {
  const {
    dataUser,
    produkMasukSP,
    setProdukMasukSP,
    jumlahMasukSP,
    setJumlahMasukSP,
    customerSP,
    handlePickCustomer,
    listProdukPrinting,
    subMenuPrinting,

    jenisPekerjaan,
    mesinSP,
    setMesinSP,
    warnaPrinting,
    setWarnaPrinting,
    produkLaporanSP,
    setProdukLaporanSP,
    setJenisPekerjaan,
    handleKirimLaporanSP,
    keteranganLaporanSP,
    setKeteranganLaporanSP,
    jumlahOkLaporanSP,
    setJumlahOkLaporanSP,
    rejectLaporanSP,
    setRejectLaporanSP,
    repairLaporanSP,
    setRepairLaporanSP,
    jumlahPengerjaanSP,
    setJumlahPengerjaanSP,
    dateLaporanSP,
    setDateLaporanSP,
    isSubmit,
    setIsSubmit,
    errMsgLaporanSP,
    addFields,
    removeFields,
    addPopUpNewReject,
    setAddPopUpNewReject,
    bagianReject,
    handlePickBagian,

    shiftProduksi,
    setShiftProduksi,
    jumlahReject,
    setJumlahReject,
    alasanRejectSP,
    setAlasanRejectSP,
    dateReject,
    setDateReject,
    dataReject,
    downtime,
    setDowntime,
    dataBarangSP,
    handleKirimBarangMasuk,
    dataBarangPolos,

    idBarangPolos,
    setIdBarangPolos,
    dataMerge,
    bulanRejectProduksi,
    setBulanRejectProduksi,
    tahunRejectProduksi,
    setTahunRejectProduksi,
    addPopUpNewPacking,
    setAddPopUpNewPacking,
    datePacking,
    setDatePacking,
    shiftPacking,
    setShiftPacking,
    mesinPacking,
    setMesinPacking,
    operatorPacking,
    setOperatorPacking,
    keteranganPacking,
    setKeteranganPacking,
    jumlahPacking,
    setJumlahPacking,
    dataPackingList,
    addFieldsPacking,
    removeFieldsPacking,
    exportRejectProduksi,
    dataSelect,
    rejectPick,
    setRejectPick,
    reStructure,
    reStructurePolos,
    isErr,
    addPopUpNewRepair,
    setAddPopUpNewRepair,
    dataRepair,
    removeFieldsRepair,
    addFieldsRepair,
    alasanRepairSP,
    setAlasanRepairSP,
    jumlahRepair,
    setJumlahRepair,

    errReject,
    clearErrReject,
    closePopupReject,
    errRepair,
    clearErrRepair,
    closePopupRepair,
  } = useSecondProcess();

  // Daftar alasan (reject/repair) sesuai role & tim, logic sama seperti sebelumnya
  const alasanList =
    validateRole() === "SP"
      ? dataUser.tim === 1
        ? rejectSP
        : rejectSPTim2
      : dataUser.tim === 1
      ? rejectPR
      : rejectPRTim2;

  const AlasanOptions = () => (
    <>
      <option value="Pilih Alasan" disabled>
        Pilih Alasan
      </option>
      {alasanList &&
        alasanList.map((ele) => (
          <option key={ele.desc} value={ele.desc}>
            {ele.desc}
          </option>
        ))}
    </>
  );

  const mesinList = dataUser.tim === 1 ? constMesinSP : constMesinSPTim2;
  const shiftList = dataUser.tim === 1 ? shiftTim1 : shiftTim2;
  const pekerjaanList =
    validateRole() === "PR"
      ? pekerjaanPrinting
      : dataUser.tim === 1
      ? pekerjaanSP
      : pekerjaanSPTim2;

  return (
    <div className="container_dashboard sp_page">
      <p className="title_inventory">
        {subMenuPrinting === "masuk"
          ? "Stock Masuk"
          : subMenuPrinting === "laporan"
          ? "Laporan Harian"
          : "Kelolosan Reject Produksi ke SP"}
      </p>

      {subMenuPrinting === "masuk" ? (
        /* ================= STOCK MASUK ================= */
        <>
          <div className="sp_card">
            <div className="sp_grid">
              <Field label="Pilih Customer">
                <select
                  className="sp_select"
                  value={customerSP}
                  onChange={(e) => handlePickCustomer(e.target.value)}
                >
                  <option value="Pilih Customer" disabled>
                    Pilih Customer
                  </option>
                  {dataBarangSP &&
                    dataBarangSP.map((ele) => (
                      <option key={ele.company} value={ele.company}>
                        {ele.company}
                      </option>
                    ))}
                </select>
              </Field>
              <Field label="Pilih Produk">
                <select
                  className="sp_select"
                  value={produkMasukSP}
                  onChange={(e) => setProdukMasukSP(e.target.value)}
                >
                  <option value="Pilih Produk" disabled>
                    Pilih Produk
                  </option>
                  {listProdukPrinting &&
                    listProdukPrinting.map((ele, i) => (
                      <option key={i} value={ele.namaBarang}>
                        {ele.namaBarang} - {ele.color}
                      </option>
                    ))}
                </select>
              </Field>
              <Field label="Jumlah Produk">
                <NumInput
                  placeholder="Jumlah Produk (Pcs)"
                  value={jumlahMasukSP}
                  onChange={(e) =>
                    setJumlahMasukSP(e.target.value.split(".").join(""))
                  }
                />
              </Field>
            </div>
          </div>
          <div className="sp_actions">
            <button
              className="button_submit_memo"
              onClick={() => handleKirimBarangMasuk()}
            >
              Kirim
            </button>
          </div>
        </>
      ) : subMenuPrinting === "laporan" ? (
        /* ================= LAPORAN HARIAN ================= */
        <>
          {/* ---------- Popup Packing ---------- */}
          {addPopUpNewPacking ? (
            <PopUpComponent>
              <PopupHead
                title="Tambah Packing List"
                onClose={() => setAddPopUpNewPacking(false)}
              />
              <div className="sp_grid_2">
                <Field label="Tanggal Produksi" required>
                  <input
                    type="date"
                    className="sp_input"
                    value={datePacking}
                    onChange={(e) => setDatePacking(e.target.value)}
                  />
                </Field>
                <Field label="Shift" required>
                  <input
                    type="text"
                    className="sp_input"
                    placeholder="Shift Injeksi"
                    value={shiftPacking}
                    onChange={(e) => setShiftPacking(e.target.value)}
                  />
                </Field>
                <Field label="Mesin" required>
                  <input
                    type="number"
                    className="sp_input"
                    placeholder="Mesin Injeksi"
                    value={mesinPacking}
                    onChange={(e) => setMesinPacking(e.target.value)}
                  />
                </Field>
                <Field label="Operator" required>
                  <input
                    type="text"
                    className="sp_input"
                    placeholder="Operator Injeksi"
                    value={operatorPacking}
                    onChange={(e) => setOperatorPacking(e.target.value)}
                  />
                </Field>
                <Field label="Jumlah" required>
                  <input
                    type="number"
                    className="sp_input"
                    placeholder="Jumlah"
                    value={jumlahPacking}
                    onChange={(e) => setJumlahPacking(e.target.value)}
                  />
                </Field>
                <Field label="Keterangan">
                  <input
                    type="text"
                    className="sp_input"
                    placeholder="Keterangan"
                    value={keteranganPacking}
                    onChange={(e) => setKeteranganPacking(e.target.value)}
                  />
                </Field>
              </div>
              <div className="sp_popup_actions">
                <button
                  className="button_submit_memo"
                  onClick={() => addFieldsPacking()}
                >
                  Kirim
                </button>
              </div>
            </PopUpComponent>
          ) : (
            ""
          )}

          {/* ---------- Popup Reject ---------- */}
          {addPopUpNewReject ? (
            <PopUpComponent>
              <PopupHead title="Tambah Reject" onClose={closePopupReject} />
              <PopupError show={Object.values(errReject).some(Boolean)} />
              <div className="sp_grid_2">
                <Field label="Pilih Tanggal" required className="sp_span_all">
                  <input
                    type="date"
                    className="sp_input"
                    value={dateReject}
                    onChange={(e) => setDateReject(e.target.value)}
                  />
                </Field>

                <Field
                  label="Bagian"
                  required
                  className="sp_span_all"
                  error={errReject.bagian}
                  errorText="Pilih salah satu bagian"
                >
                  <div
                    className={`sp_check_row ${
                      errReject.bagian ? "sp_check_row_error" : ""
                    }`}
                  >
                    {["SP", "Produksi"].map((b) => (
                      <label
                        key={b}
                        className={`sp_check ${
                          bagianReject === b ? "sp_check_active" : ""
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={bagianReject === b}
                          onChange={() => handlePickBagian(b)}
                        />
                        {b}
                      </label>
                    ))}
                  </div>
                </Field>

                {bagianReject === "Produksi" ? (
                  <>
                    <Field
                      label="Reject Produksi"
                      required
                      error={errReject.rejectPick}
                      errorText="Pilih jenis reject"
                    >
                      <div
                        className={`sp_select_wrap ${
                          errReject.rejectPick ? "sp_select_wrap_error" : ""
                        }`}
                      >
                        <Select
                          classNamePrefix="rs"
                          options={dataSelect}
                          value={rejectPick || ""}
                          onChange={(v) => {
                            setRejectPick(v);
                            clearErrReject("rejectPick");
                          }}
                        />
                      </div>
                    </Field>
                    <Field
                      label="Pilih Shift"
                      required
                      error={errReject.shift}
                      errorText="Shift wajib dipilih"
                    >
                      <select
                        className={
                          errReject.shift
                            ? "sp_select sp_select_error"
                            : "sp_select"
                        }
                        value={shiftProduksi}
                        onChange={(e) => {
                          setShiftProduksi(e.target.value);
                          clearErrReject("shift");
                        }}
                      >
                        <option value="Pilih Shift" disabled>
                          Pilih Shift
                        </option>
                        {shiftList &&
                          shiftList.map((ele) => (
                            <option key={ele} value={ele}>
                              {ele}
                            </option>
                          ))}
                      </select>
                    </Field>
                  </>
                ) : null}

                {bagianReject === "SP" ? (
                  <Field
                    label="Reject SP"
                    required
                    error={errReject.alasan}
                    errorText="Alasan wajib dipilih"
                  >
                    <select
                      className={
                        errReject.alasan
                          ? "sp_select sp_select_error"
                          : "sp_select"
                      }
                      value={alasanRejectSP}
                      onChange={(e) => {
                        setAlasanRejectSP(e.target.value);
                        clearErrReject("alasan");
                      }}
                    >
                      <AlasanOptions />
                    </select>
                  </Field>
                ) : null}

                <Field
                  label="Jumlah Reject"
                  required
                  error={errReject.jumlah}
                  errorText="Isi jumlah lebih dari 0"
                >
                  <NumInput
                    error={errReject.jumlah}
                    placeholder="Jumlah Reject"
                    value={jumlahReject}
                    onChange={(e) => {
                      setJumlahReject(e.target.value.split(".").join(""));
                      clearErrReject("jumlah");
                    }}
                  />
                </Field>
              </div>
              <div className="sp_popup_actions">
                <button
                  className="button_submit_memo sp_btn_ghost"
                  onClick={closePopupReject}
                >
                  Batal
                </button>
                <button
                  className="button_submit_memo"
                  onClick={() => addFields()}
                >
                  Tambah
                </button>
              </div>
            </PopUpComponent>
          ) : null}

          {/* ---------- Popup Repair ---------- */}
          {addPopUpNewRepair ? (
            <PopUpComponent>
              <PopupHead title="Tambah Repair" onClose={closePopupRepair} />
              <PopupError show={Object.values(errRepair).some(Boolean)} />
              <div className="sp_grid_2">
                <Field label="Pilih Tanggal" required className="sp_span_all">
                  <input
                    type="date"
                    className="sp_input"
                    value={dateReject}
                    onChange={(e) => setDateReject(e.target.value)}
                  />
                </Field>
                <Field
                  label="Repair SP"
                  required
                  error={errRepair.alasan}
                  errorText="Alasan wajib dipilih"
                >
                  <select
                    className={
                      errRepair.alasan
                        ? "sp_select sp_select_error"
                        : "sp_select"
                    }
                    value={alasanRepairSP}
                    onChange={(e) => {
                      setAlasanRepairSP(e.target.value);
                      clearErrRepair("alasan");
                    }}
                  >
                    <AlasanOptions />
                  </select>
                </Field>
                <Field
                  label="Jumlah Repair"
                  required
                  error={errRepair.jumlah}
                  errorText="Isi jumlah lebih dari 0"
                >
                  <NumInput
                    error={errRepair.jumlah}
                    placeholder="Jumlah Repair"
                    value={jumlahRepair}
                    onChange={(e) => {
                      setJumlahRepair(e.target.value.split(".").join(""));
                      clearErrRepair("jumlah");
                    }}
                  />
                </Field>
              </div>
              <div className="sp_popup_actions">
                <button
                  className="button_submit_memo sp_btn_ghost"
                  onClick={closePopupRepair}
                >
                  Batal
                </button>
                <button
                  className="button_submit_memo"
                  onClick={() => addFieldsRepair()}
                >
                  Tambah
                </button>
              </div>
            </PopUpComponent>
          ) : null}

          {/* ---------- Popup Sukses ---------- */}
          {isSubmit ? (
            <PopUpComponent>
              <p className="sp_popup_text">
                Terima Kasih! Data Kamu Sudah Terkirim
              </p>
              <div className="sp_popup_actions">
                <button
                  className="button_submit_memo"
                  onClick={() => setIsSubmit(false)}
                >
                  OK
                </button>
              </div>
            </PopUpComponent>
          ) : (
            ""
          )}

          {errMsgLaporanSP ? (
            <p className="sp_error_banner">Mohon Mengisi kolom berbintang!</p>
          ) : (
            ""
          )}

          {/* ---------- Data Laporan ---------- */}
          <div className="sp_card">
            <p className="sp_card_title" style={{ marginBottom: "12px" }}>
              Data Laporan
            </p>
            <div className="sp_grid">
              <Field label="Pilih Tanggal" required>
                <input
                  type="date"
                  className="sp_input"
                  value={dateLaporanSP}
                  onChange={(e) => setDateLaporanSP(e.target.value)}
                />
              </Field>
              <Field label="Mesin" required>
                <select
                  className="sp_select"
                  value={mesinSP}
                  onChange={(e) => setMesinSP(e.target.value)}
                >
                  <option value="Pilih Mesin" disabled>
                    Pilih Mesin
                  </option>
                  {mesinList &&
                    mesinList.map((ele) => (
                      <option key={ele} value={ele}>
                        {ele}
                      </option>
                    ))}
                </select>
              </Field>
              <Field label="Pilih Customer" required>
                <select
                  className="sp_select"
                  value={customerSP}
                  onChange={(e) => handlePickCustomer(e.target.value)}
                >
                  <option value="Pilih Customer" disabled>
                    Pilih Customer
                  </option>
                  {dataBarangPolos &&
                    dataBarangPolos.map((ele) => (
                      <option key={ele.company} value={ele.company}>
                        {ele.company}
                      </option>
                    ))}
                </select>
              </Field>
              <Field label="Pilih Produk Jadi" required>
                <div className="sp_select_wrap">
                  <Select
                    options={reStructure && reStructure}
                    value={produkLaporanSP || ""}
                    onChange={setProdukLaporanSP}
                  />
                </div>
              </Field>
              <Field label="Pilih Produk Polos" required>
                <div className="sp_select_wrap">
                  <Select
                    options={reStructurePolos}
                    value={idBarangPolos || ""}
                    onChange={setIdBarangPolos}
                  />
                </div>
              </Field>
              <Field label="Jenis Pekerjaan" required>
                <select
                  className="sp_select"
                  value={jenisPekerjaan}
                  onChange={(e) => setJenisPekerjaan(e.target.value)}
                >
                  <option value="Pilih Jenis Pekerjaan" disabled>
                    Pilih Jenis Pekerjaan
                  </option>
                  {pekerjaanList &&
                    pekerjaanList.map((ele) => (
                      <option
                        key={ele.jenisPekerjaan}
                        value={ele.jenisPekerjaan}
                      >
                        {ele.jenisPekerjaan}
                      </option>
                    ))}
                </select>
              </Field>
              {jenisPekerjaan === "Print" ? (
                <Field label="Pilih Warna" required>
                  <select
                    className="sp_select"
                    value={warnaPrinting}
                    onChange={(e) => setWarnaPrinting(e.target.value)}
                  >
                    <option value="Pilih Warna" disabled>
                      Pilih Warna
                    </option>
                    {constWarnaPrinting &&
                      constWarnaPrinting.map((ele) => (
                        <option key={ele} value={ele}>
                          {ele}
                        </option>
                      ))}
                  </select>
                </Field>
              ) : (
                ""
              )}
              <Field label="Jumlah OK" required>
                <NumInput
                  placeholder="Jumlah OK"
                  value={jumlahOkLaporanSP}
                  onChange={(e) =>
                    setJumlahOkLaporanSP(e.target.value.split(".").join(""))
                  }
                />
              </Field>
              <Field label="Jumlah Reject" error={isErr}>
                <NumInput
                  error={isErr}
                  placeholder="Jumlah Reject"
                  value={rejectLaporanSP}
                  onChange={(e) =>
                    setRejectLaporanSP(e.target.value.split(".").join(""))
                  }
                />
              </Field>
              {validateRole() === "PR" ? (
                <Field label="Repair" error={isErr}>
                  <NumInput
                    error={isErr}
                    placeholder="Jumlah Repair"
                    value={repairLaporanSP}
                    onChange={(e) =>
                      setRepairLaporanSP(e.target.value.split(".").join(""))
                    }
                  />
                </Field>
              ) : (
                ""
              )}
              <Field label="Jumlah Pengerjaan" required>
                <input
                  type="text"
                  className="sp_input"
                  placeholder="Jumlah Pengerjaan"
                  value={jumlahPengerjaanSP}
                  onChange={(e) => setJumlahPengerjaanSP(e.target.value)}
                />
              </Field>
              <Field label="Downtime (Menit)">
                <NumInput
                  placeholder="Downtime (Menit)"
                  value={downtime}
                  onChange={(e) =>
                    setDowntime(e.target.value.split(".").join(""))
                  }
                />
              </Field>
            </div>
          </div>

          {/* ---------- Kind Of Repair (PR) ---------- */}
          {validateRole() === "PR" ? (
            <div className="sp_card">
              <div className="sp_card_head">
                <p
                  className={
                    isErr
                      ? "sp_card_title sp_card_title_error"
                      : "sp_card_title"
                  }
                >
                  Kind Of Repair
                </p>
                <StepButtons
                  onRemove={removeFieldsRepair}
                  onAdd={() => setAddPopUpNewRepair(true)}
                />
              </div>
              <div
                className={
                  isErr ? "sp_table_wrap sp_table_wrap_error" : "sp_table_wrap"
                }
              >
                <table className="sp_table">
                  <thead>
                    <tr>
                      <th>Repair</th>
                      <th>Tgl</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataRepair && dataRepair.length > 0 ? (
                      dataRepair.map((obj, index) => (
                        <tr key={index}>
                          <td>{obj.id}</td>
                          <td className="sp_nowrap">{obj.dateRepair}</td>
                          <td>{obj.repair}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="sp_table_empty">
                          Belum ada data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            ""
          )}

          {/* ---------- Kind Of Reject ---------- */}
          <div className="sp_card">
            <div className="sp_card_head">
              <p
                className={
                  isErr ? "sp_card_title sp_card_title_error" : "sp_card_title"
                }
              >
                Kind Of Reject
              </p>
              <StepButtons
                onRemove={removeFields}
                onAdd={() => setAddPopUpNewReject(true)}
              />
            </div>
            <div
              className={
                isErr ? "sp_table_wrap sp_table_wrap_error" : "sp_table_wrap"
              }
            >
              <table className="sp_table">
                <thead>
                  <tr>
                    <th>Reject</th>
                    <th>Tgl</th>
                    <th>Bagian</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {dataReject && dataReject.length > 0 ? (
                    dataReject.map((obj, index) => (
                      <tr key={index}>
                        <td>{obj.id}</td>
                        <td className="sp_nowrap">{obj.dateReject}</td>
                        <td>{obj.shift ? obj.shift : obj.bagian}</td>
                        <td>{obj.reject}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="sp_table_empty">
                        Belum ada data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* ---------- Packing List ---------- */}
          <div className="sp_card">
            <div className="sp_card_head">
              <p className="sp_card_title">Packing List</p>
              <StepButtons
                onRemove={removeFieldsPacking}
                onAdd={() => setAddPopUpNewPacking(true)}
              />
            </div>
            <div className="sp_table_wrap">
              <table className="sp_table">
                <thead>
                  <tr>
                    <th>Tgl</th>
                    <th>Mc</th>
                    <th>Shift</th>
                    <th>Operator</th>
                    <th>Jumlah</th>
                    <th>Keterangan</th>
                  </tr>
                </thead>
                <tbody>
                  {dataPackingList && dataPackingList.length > 0 ? (
                    dataPackingList.map((obj, index) => (
                      <tr key={index}>
                        <td className="sp_nowrap">
                          {moment(obj.date).format("YYYY-MM-DD")}
                        </td>
                        <td>{obj.mesin}</td>
                        <td>{obj.shift}</td>
                        <td>{obj.operator}</td>
                        <td>{obj.jumlah}</td>
                        <td>{obj.keterangan}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="sp_table_empty">
                        Belum ada data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* ---------- Keterangan ---------- */}
          <div className="sp_card">
            <p className="sp_card_title" style={{ marginBottom: "12px" }}>
              Keterangan
            </p>
            <textarea
              className="sp_textarea"
              placeholder="Keterangan Laporan"
              value={keteranganLaporanSP}
              onChange={(e) => setKeteranganLaporanSP(e.target.value)}
            />
          </div>

          <div className="sp_actions">
            <button
              className="button_submit_memo sp_btn_ghost"
              onClick={() =>
                navigator.clipboard.readText().then(
                  (cliptext) => setKeteranganLaporanSP(cliptext),
                  (err) => console.log(err)
                )
              }
            >
              Tempel
            </button>
            <button
              className="button_submit_memo"
              onClick={() => handleKirimLaporanSP()}
            >
              Kirim
            </button>
          </div>
        </>
      ) : (
        /* ================= KELOLOSAN REJECT PRODUKSI ================= */
        <>
          <div className="sp_card">
            <div className="sp_filter_row">
              <Field label="Bulan">
                <select
                  className="sp_select"
                  onChange={(e) => setBulanRejectProduksi(e.target.value)}
                  value={bulanRejectProduksi}
                >
                  <option value="Bulan" disabled>
                    Bulan
                  </option>
                  {bulan.map((ele) => (
                    <option key={ele.value} value={ele.value}>
                      {ele.name}
                    </option>
                  ))}
                </select>
              </Field>
              <Field label="Tahun">
                <select
                  className="sp_select"
                  onChange={(e) => setTahunRejectProduksi(e.target.value)}
                  value={tahunRejectProduksi}
                >
                  <option value="Tahun" disabled>
                    Tahun
                  </option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
              </Field>
              {dataUser.role !== "produksi_leader" ? (
                <button
                  className="sp_btn_export"
                  onClick={() => exportRejectProduksi()}
                >
                  Export
                </button>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="sp_card">
            <div className="sp_table_wrap">
              <table className="sp_table">
                <thead>
                  <tr>
                    <th>Part Name</th>
                    <th>Warna</th>
                    <th>Customer</th>
                    <th>Shift</th>
                    <th>Reject</th>
                    <th>Jumlah</th>
                    <th>Tgl Produksi</th>
                    <th>Tgl Laporan</th>
                  </tr>
                </thead>
                <tbody>
                  {dataMerge && dataMerge.length > 0 ? (
                    dataMerge.map((ele, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: "left" }}>{ele.produk}</td>
                        <td>{ele.color}</td>
                        <td>{ele.customer}</td>
                        <td style={{ textAlign: "left" }}>{ele.shift}</td>
                        <td className="sp_nowrap" style={{ textAlign: "left" }}>
                          {ele.id}
                        </td>
                        <td>{ele.reject}</td>
                        <td className="sp_nowrap">
                          {moment(ele.dateReject).format("DD-MM-YYYY")}
                        </td>
                        <td className="sp_nowrap">
                          {moment(ele.date).format("DD-MM-YYYY")}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="sp_table_empty">
                        Belum ada data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default SecondProcess;
